import EffectContainer from './EffectContainer';
import styles from './Loading.module.scss';
import IMG_LOADING from '../../../public/static/v4/common/icon-loading.png';
import useTypedSelector from '../hook/useTypedSelector';
import {IEffectStyle, EffectType} from '../type';

interface IProps {
  show?: boolean;
  isFull?: boolean;
  size?: number;
  className?: string;
}

export default function Loading({
  show = true,
  isFull = false,
  size = 24,
  className,
}: IProps) {
  const [isAppMounted, isExistAlert] = useTypedSelector(state => [
    state.common.isAppMounted,
    !!state.common.pAlerts.length,
  ]);

  if (isFull && isExistAlert) {
    return null;
  }

  let resultElement = isFull ? (
    <img
      src={IMG_LOADING}
      className={cn(
        'm-auto',
        'overflow-hidden relative',
        'animate-spin',
        className
      )}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: ANIMATE_SPIN_DURATION,
      }}
      alt=""
    />
  ) : (
    <div className={cn('flex', className)}>
      <img
        src={IMG_LOADING}
        className="m-auto animate-spin"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          animationDuration: ANIMATE_SPIN_DURATION,
        }}
        alt=""
      />
    </div>
  );
  resultElement = isAppMounted ? (
    <EffectContainer show={show} effectStyleList={EFFECT_STYLE_LIST}>
      {resultElement}
    </EffectContainer>
  ) : show ? (
    <div className={cn('opacity-0', styles.fadeIn)}>{resultElement}</div>
  ) : (
    <div />
  );
  return isFull ? (
    <div
      className={cn(
        'absolute left-1/2 top-1/2',
        '-translate-x-1/2 -translate-y-1/2',
        'z-loading',
        className
      )}
    >
      {resultElement}
    </div>
  ) : (
    resultElement
  );
}

const EFFECT_STYLE_LIST: IEffectStyle[] = [
  {
    type: EffectType.Transform,
    defaultValue: 'scale(1.0)',
    value: {
      entering: 'scale(0.7)',
      exiting: 'scale(0.7)',
    },
  },
  {
    type: EffectType.Opacity,
    defaultValue: 1,
    value: {entering: 0, exiting: 0},
  },
];

const ANIMATE_SPIN_DURATION = '500ms';
